import Chip from "@mui/material/Chip";

const BAND_SX = {
	EXCELLENT: { backgroundColor: "#e8f5e9", color: "#1b5e20" },
	GOOD: { backgroundColor: "#e8f5e9", color: "#2e7d32" },
	FAIR: { backgroundColor: "#fff8e1", color: "#f57f17" },
	POOR: { backgroundColor: "#ffebeb", color: "#c62828" },
	NEW: { backgroundColor: "#FEF0DE", color: "#6d4c00" },
};

const bandLabel = (band) => {
	if (!band) return "";
	const text = String(band).toLowerCase();
	return text.charAt(0).toUpperCase() + text.slice(1);
};

export default function ScoreChip({ creditScore }) {
	if (!creditScore || creditScore.score == null) {
		return "—";
	}
	const band = creditScore.band || "NEW";
	return (
		<Chip
			size="small"
			variant="outlined"
			label={`${creditScore.score} · ${bandLabel(band)}`}
			sx={{
				fontSize: "10px",
				fontWeight: 700,
				...BAND_SX[band],
			}}
		/>
	);
}

export const formatRbPoints = (value) => {
	if (value == null || value === "") return "0";
	return String(value);
};
